import { Box } from '@mui/material'
import CommonLoaderBackdrop from '../Common/CommonLoaderBackdrop'
import sxs from './_sxs'

export const UserLoader = () => (
    <>
        <CommonLoaderBackdrop open label="Chargement des informations de l'utilisateur..." />
        <Box
            sx={[
                sxs.UserForm,
                {
                    height: '80dvh',
                },
            ]}
        />
    </>
)
